import type { SubmitEvent } from "react";
import { useState } from "react";
import type { FeatureFlag } from "./featureFlags/featureFlags";
import { featureFlags } from "./featureFlags/featureFlags";
import { entries } from "lodash";
import { Button } from "@mui/material";
import { deleteCustomer, getCustomer } from "./customers/customersApi";
import { AxiosError } from "axios";
import ExternalCrmMigration from "./externalCrm/ExternalCrmMigration";

export function Maintenance() {
  return (
    <div>
      <h1>Maintenance</h1>
      <FeatureFlags />
      <DeleteCustomers />
      <ExternalCrmMigration />
    </div>
  );
}
function FeatureFlags() {
  return (
    <div>
      <h1>Feature flags</h1>
      {entries(featureFlags.admin.list()).map(([flag, enabled]) => (
        <label style={{ userSelect: "none", display: "block" }} key={flag}>
          <input
            type="checkbox"
            defaultChecked={enabled}
            onChange={(e) => {
              if (e.currentTarget.checked) {
                featureFlags.admin.enable(flag as FeatureFlag);
              } else {
                featureFlags.admin.disable(flag as FeatureFlag);
              }
            }}
          />
          {flag}
        </label>
      ))}
      <div style={{ marginTop: "1.5em" }}>
        <button onClick={() => window.location.reload()}>Refresh</button>
      </div>
    </div>
  );
}

function DeleteCustomers() {
  const [customerIds, setCustomerIds] = useState<string[]>([]);
  const [log, setLog] = useState("");

  async function handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    if (!confirm(`Usunąć klientów: ${customerIds.length}?`)) {
      return;
    }
    setLog(`Usuwam ${customerIds.length}:\n`);
    for (const id of customerIds) {
      setLog((log) => `${log}\n${id}: `);
      try {
        try {
          await getCustomer(id);
        } catch (e) {
          console.error(e);

          if (e instanceof AxiosError && e.status === 404) {
            setLog((log) => `${log} niepoprawny id - brak takiego klienta`);
          }
          continue;
        }
        await deleteCustomer(id);
        setLog((log) => `${log}check`);
        try {
          await getCustomer(id);
        } catch (e) {
          if (e instanceof AxiosError && e.status === 404) {
            setLog((log) => `${log} ok`);
          } else {
            // noinspection ExceptionCaughtLocallyJS
            throw e;
          }
        }
      } catch (e) {
        setLog((log) => `${log}${e}`);
      }
    }
    setLog((log) => `${log}\n\nSkończone`);
  }

  return (
    <div>
      <h1>Usuwanie klientów</h1>
      <div style={{ display: "flex", gap: "2rem", marginTop: "1rem", alignItems: "flex-start" }}>
        <div>
          <form onSubmit={handleSubmit}>
            <textarea
              rows={12}
              cols={40}
              placeholder="Wklej ID klientów oddzielone spacją lub nową linią"
              onChange={(e) => {
                const ids = e.currentTarget.value
                  .split(/\s+/g)
                  .map((it) => it.trim())
                  .filter((it) => it.length > 0);
                setCustomerIds(ids);
              }}
            />
            <br />
            <Button type="submit" color="error" variant="contained" disabled={customerIds.length === 0}>
              Usuń {customerIds.length}
            </Button>
          </form>
        </div>
        <div style={{ flex: 1 }}>
          <pre
            style={{
              background: "#f5f5f5",
              padding: "1rem",
              maxHeight: "300px",
              overflowY: "auto",
              border: "1px solid #ccc",
              margin: 0,
            }}
          >
            {log}
          </pre>
        </div>
      </div>
    </div>
  );
}
